import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/src/app/[slug]/page.js");
